import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { ArrowRight } from "lucide-react";

const NUMBERS = [
  ["Life Path Number", "The central theme of your journey, derived from your full date of birth."],
  ["Birth Day Number", "A specific gift or trait tied to the day of the month you were born."],
  ["Expression / Destiny", "What your full birth name suggests about your natural direction."],
  ["Soul Urge Number", "Your inner motivations, drawn from the vowels in your name."],
  ["Personality Number", "How others tend to perceive you, drawn from the consonants."],
  ["Personal Year Number", "The theme of your current year, useful for reflection and planning."],
];

export default function Reports() {
  return (
    <>
      <Seo title="Numerology Reports" path="/reports" />
      <PageHeader eyebrow="Numerology reports" title="What your report explores"
        subtitle="Each report interprets a set of core numbers calculated from your name and birth date, explained in accessible, balanced language." />
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-12 py-16 lg:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {NUMBERS.map(([t, d]) => (
            <div key={t} className="bg-white rounded-2xl border border-border p-7 card-lift">
              <h3 className="font-serif text-2xl text-navy mb-2">{t}</h3>
              <p className="text-slate-600 text-sm leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
        <div className="mt-14 bg-paper rounded-2xl p-8 sm:p-10 border border-border">
          <h2 className="font-serif text-3xl text-navy mb-3">Two methodologies, kept separate</h2>
          <p className="text-slate-600 leading-relaxed max-w-3xl">
            We offer both <strong>Pythagorean</strong> and <strong>Chaldean</strong> numerology — two
            traditions that map letters to numbers in their own way. Choose the one that speaks to you
            at checkout; your report follows that tradition faithfully, from first calculation to final
            word.
          </p>
          <Link to="/pricing" className="btn-primary mt-6">Get your report <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </section>
    </>
  );
}
